//文字コードはutf-8

function getHeaderHeight() {
  const header = document.querySelector('.header__nav');
  return header ? header.offsetHeight : 0;
}

function getTargetTop(target) {
  const rect = target.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return Math.max(0, rect.top + scrollTop - getHeaderHeight() - 20);
}

function animateScroll(targetTop) {
  const startTop = window.pageYOffset || document.documentElement.scrollTop;
  const distance = targetTop - startTop;
  if (distance === 0) return;
  const duration = 600;
  let startTime = null;

  // Ease-out (quadratic) — quick start, gentle deceleration into the target.
  function easeOutQuad(t) {
    return 1 - (1 - t) * (1 - t);
  }

  function step(currentTime) {
    if (!startTime) startTime = currentTime;
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    // behavior: 'instant' overrides CSS `scroll-behavior: smooth` so the browser
    // doesn't re-smooth each frame — the JS easing is the only animation.
    window.scrollTo({ top: startTop + distance * easeOutQuad(progress), behavior: 'instant' });
    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }

  requestAnimationFrame(step);
}

export function initSmoothScroll() {
  // 同一ページ内アンカーリンクのクリック
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    const hash = link.getAttribute('href');
    if (hash === '#') return;
    const target = document.querySelector(hash);
    if (!target) return;
    e.preventDefault();
    animateScroll(getTargetTop(target));
    history.pushState(null, '', hash);
  });

  // ページ読み込み時のハッシュ対応
  const hash = window.location.hash;
  if (hash) {
    const target = document.querySelector(hash);
    if (target) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      requestAnimationFrame(() => {
        animateScroll(getTargetTop(target));
      });
    }
  }
}
